import React from 'react';
import { Link } from 'react-router-dom';
import { FiClock, FiArrowUpRight, FiTag } from 'react-icons/fi';
import './BlogCard.css';
import { resolveMedia } from '../../utils/media';

export default function BlogCard({ item }) {
  const date = item.publishedAt || item.createdAt;
  return (
    <article className="blc"><div className="blc__media"><img className="blc__img" src={resolveMedia(item.coverImage)} alt={item.title} /><div className="blc__badge"><FiTag /> {item.category || 'General'}</div></div><div className="blc__body"><div className="blc__meta"><span className="blc__metaItem"><FiClock /> {date ? new Date(date).toLocaleDateString() : ''}</span></div><h3 className="blc__title">{item.title}</h3><p className="blc__desc">{item.excerpt}</p><Link className="blc__btn" to={`/blog/${item.slug}`}>Read Article <FiArrowUpRight /></Link></div></article>
  );
}
